import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "overview-metrics" }
const _hoisted_2 = { class: "metric-block" }
const _hoisted_3 = { class: "block-hd" }
const _hoisted_4 = { class: "block-title" }
const _hoisted_5 = { class: "handlers-container" }
const _hoisted_6 = { class: "metric-name" }
const _hoisted_7 = { class: "metric-num" }
const _hoisted_8 = ["id"]
const _hoisted_9 = { class: "metric-types front" }
const _hoisted_10 = { class: "front-hd" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", {
  class: "dot-type",
  style: {"background-color":"#bac1cd"}
}, null, -1)
const _hoisted_12 = { class: "metric-name" }
const _hoisted_13 = { class: "front-body" }
const _hoisted_14 = { class: "metric-num" }
const _hoisted_15 = { class: "front-hd" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", {
  class: "dot-type",
  style: {"background-color":"#7fd7b8"}
}, null, -1)
const _hoisted_17 = { class: "metric-name" }
const _hoisted_18 = { class: "front-body" }
const _hoisted_19 = { class: "metric-num" }
const _hoisted_20 = { class: "front-hd" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", {
  class: "dot-type",
  style: {"background-color":"#fdafa6"}
}, null, -1)
const _hoisted_22 = { class: "metric-name" }
const _hoisted_23 = { class: "front-body" }
const _hoisted_24 = { class: "metric-num" }
const _hoisted_25 = { class: "front-hd" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", {
  class: "dot-type",
  style: {"background-color":"#fdafa6"}
}, null, -1)
const _hoisted_27 = { class: "metric-name" }
const _hoisted_28 = { class: "front-body" }
const _hoisted_29 = { class: "metric-num" }

import { parseAuthLanguage } from '@/common/tools'
import useI18nTl from '@/hooks/useI18nTl'
import { Refresh } from '@element-plus/icons-vue'
import { watch, ref, onMounted } from 'vue'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import { getOrderStatByAuth } from '@/api/operation'
import Moment from 'moment'

import { usePieChart, MetricType } from '@/hooks/useMetrics'


import { computed, defineComponent, defineProps } from 'vue'

const __default__ = defineComponent({
  name: 'StationOverview',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  stationID: {
    type: String,
    default: '0',
  },
},
  setup(__props) {

const props = __props

const { timeRanges } = useProtocolEnums()
const { t } = useI18nTl('Operation')



/* PIE */
let pieData = []
const setChartId = (name: string) => {
  return `pie-chart-${name}`
}
const { updatePieData } = usePieChart()

const timeRange = ref(3)
const isLoading = ref(false)
const beginTime = ref('')
const endTime = ref('')

const timeRangeOptions = [
  // { label: t('Dashboard.last24Hour'), value: 1 },
  // { label: t('Dashboard.yesterday'), value: 2 },
  { label: t('Dashboard.last30Day'), value: 3 },
  { label: t('Dashboard.currentMonth'), value: 4 },
  { label: t('Dashboard.lastMonth'), value: 5 },
  { label: t('Dashboard.last12Month'), value: 6 },
  { label: t('Dashboard.currentYear'), value: 7 },
  { label: t('Dashboard.lastYear'), value: 8 },
]

const parseTimeRange = () => {
  switch (timeRange.value) {
    case 1:
      beginTime.value = Moment().subtract(23, 'hours').format('YYYY-MM-DD HH:mm:ss')
      endTime.value = Moment().endOf('hours').format('YYYY-MM-DD HH:mm:ss')
      break
    case 2:
      beginTime.value = Moment().subtract(1, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss')
      endTime.value = Moment().subtract(1, 'days').endOf('day').format('YYYY-MM-DD HH:mm:ss')
      break
    case 3:
      beginTime.value = Moment().subtract(30, 'days').format('YYYY-MM-DD HH:mm:ss')
      endTime.value = Moment().format('YYYY-MM-DD HH:mm:ss')
      break
    case 4:
      beginTime.value = Moment().startOf('month').format('YYYY-MM-DD HH:mm:ss')
      endTime.value = Moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')
      break
    case 5:
      beginTime.value = Moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD HH:mm:ss')
      endTime.value = Moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD HH:mm:ss')
      break
    case 6:
      beginTime.value = Moment()
        .subtract(11, 'month')
        .startOf('month')
        .format('YYYY-MM-DD HH:mm:ss')
      endTime.value = Moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD HH:mm:ss')
      break
    case 7:
      beginTime.value = Moment().startOf('year').format('YYYY-MM-DD HH:mm:ss')
      endTime.value = Moment().endOf('year').format('YYYY-MM-DD HH:mm:ss')
      break
    case 8:
      beginTime.value = Moment().subtract(1, 'year').startOf('year').format('YYYY-MM-DD HH:mm:ss')
      endTime.value = Moment().subtract(1, 'year').endOf('year').format('YYYY-MM-DD HH:mm:ss')
      break
  }
}
watch(timeRange, () => {
  parseTimeRange()
  loadData()
})

const totalOrderNum = ref(0)
const totalOrderElec = ref(0)
const totalOrderElecAmount = ref(0)
const totalOrderSrvAmount = ref(0)
const successOrderNum = ref(0)
const abnormalRate = computed(() => {
  if (totalOrderNum.value == 0) {
    return 0
  }
  return (((totalOrderNum.value - successOrderNum.value) / totalOrderNum.value) * 100).toFixed(2)
})

const loadData = async function () {
  totalOrderNum.value = 0
  totalOrderElec.value = 0
  totalOrderElecAmount.value = 0
  totalOrderSrvAmount.value = 0
  successOrderNum.value = 0

  try {
    isLoading.value = true
    console.log('loadData', beginTime.value, endTime.value, props.stationID)
    const data = await getOrderStatByAuth({
      beginTime: beginTime.value,
      endTime: endTime.value,
      stationID: props.stationID,
    })

    let showdata = [] as any[]
    data.stats.forEach((stat: any) => {
      totalOrderNum.value += stat.totalOrderNum
      successOrderNum.value += stat.totalChargingOrder
      totalOrderElec.value += stat.totalElec
      totalOrderElecAmount.value += stat.totalElecAmount
      totalOrderSrvAmount.value += stat.totalServiceAmount
      if (stat.totalOrderNum > 0) {
        showdata.push({
          name: t(parseAuthLanguage(stat.tag)),
          value: stat.totalOrderNum,
          type: MetricType.Green,
        })
      }
    })
    totalOrderElec.value = totalOrderElec.value.toFixed(2)
    totalOrderElecAmount.value = totalOrderElecAmount.value.toFixed(2)
    totalOrderSrvAmount.value = totalOrderSrvAmount.value.toFixed(2)
    updatePieData(`pie-chart-auth-evse`, showdata)
  } catch (error) {
    //
  } finally {
    isLoading.value = false
  }
}

// 监听 props.stationID 的变化
watch(
  () => props.stationID,
  (newVal) => {
    if (newVal !== '0') {
      parseTimeRange()
      loadData()
    }
  },
)

// 在组件挂载时检查 props.stationID
onMounted(() => {
  if (props.stationID !== '0') {
    parseTimeRange()
    loadData()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('Base.statistics')), 1),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_select, {
            modelValue: timeRange.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((timeRange).value = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(timeRangeOptions, ({ value, label }) => {
                return _createVNode(_component_el_option, {
                  key: value,
                  label: label,
                  value: value
                }, null, 8, ["label", "value"])
              }), 64))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_el_tooltip, {
            content: _ctx.$t('Base.refresh'),
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                class: "icon-button",
                type: "primary",
                icon: _unref(Refresh),
                onClick: loadData
              }, null, 8, ["icon"])
            ]),
            _: 1
          }, 8, ["content"])
        ])
      ]),
      _createVNode(_component_el_row, {
        gutter: 24,
        class: "block-bd stats-numbers flow-node-row"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 8 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { class: "metric-pie" }, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('Evses.orderAuthStat')), 1),
                  _createElementVNode("p", _hoisted_7, _toDisplayString(totalOrderNum.value), 1),
                  _createElementVNode("div", {
                    class: "pie-container",
                    id: setChartId('auth-evse')
                  }, null, 8, _hoisted_8)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 16 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_el_row, { gutter: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_card, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_10, [
                              _hoisted_11,
                              _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('Evses.anomalyRate')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(abnormalRate)) + " %", 1)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_card, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_15, [
                              _hoisted_16,
                              _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t('Evses.electricityStat')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("p", _hoisted_19, _toDisplayString(totalOrderElec.value), 1)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_card, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_20, [
                              _hoisted_21,
                              _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.$t('Evses.amountStat')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("p", _hoisted_24, _toDisplayString(totalOrderElecAmount.value), 1)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_card, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_25, [
                              _hoisted_26,
                              _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.$t('Evses.amountService')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("p", _hoisted_29, _toDisplayString(totalOrderSrvAmount.value), 1)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})